
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export const DrawerContext = createContext<{
  onClose: () => void;
  setOnClose: (fn: () => void) => void;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}>({
  onClose: () => { },
  setOnClose: () => { },
  setIsModalOpen: () => { },
});

export const useDrawer = () => useContext(DrawerContext);